import React, { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

interface SkipControlProps {
  onSkip: () => void
  isVisible: boolean
}

export function SkipControl({ onSkip, isVisible }: SkipControlProps) {
  const [delayedShow, setDelayedShow] = useState(false)

  // Fade in the skip control after a 800ms delay to prevent immediate visual distraction
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => setDelayedShow(true), 800)
      return () => clearTimeout(timer)
    } else {
      setDelayedShow(false)
    }
  }, [isVisible])

  return (
    <AnimatePresence>
      {delayedShow && (
        <motion.button
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          onClick={onSkip}
          style={{
            position: 'absolute',
            top: '24px',
            right: '24px',
            padding: '8px 16px',
            background: 'rgba(255, 255, 255, 0.04)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            backdropFilter: 'blur(8px)',
            borderRadius: '6px',
            color: 'rgba(255, 255, 255, 0.6)',
            fontSize: '12px',
            fontFamily: 'sans-serif',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            zIndex: 410, // Stays on top of active experience contents
            transition: 'color 0.2s, background-color 0.2s, border-color 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#ffffff'
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)'
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = 'rgba(255, 255, 255, 0.6)'
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.04)'
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.08)'
          }}
          title="Press Escape to skip"
        >
          <span>Skip</span>
          <kbd
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              padding: '2px 4px',
              borderRadius: '3px',
              fontSize: '10px',
              textTransform: 'uppercase',
              color: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            Esc
          </kbd>
        </motion.button>
      )}
    </AnimatePresence>
  )
}
